import { render, staticRenderFns } from "./RepeatDeliveryModal.vue?vue&type=template&id=1f155f78&lang=pug"
import script from "./RepeatDeliveryModal.vue?vue&type=script&lang=js"
export * from "./RepeatDeliveryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports